<bb-activity-monitor-layout
  [isOpen]="(isOpen$ | async) || false"
  [remaining]="(remaining$ | async) || 0"
></bb-activity-monitor-layout>
